import React, { useEffect, useState } from 'react';
import HomePage from './pages/HomePage';
import FAQPage from './pages/FAQPage';
import { Toaster } from './toaster';
import './index.css';

function App() {
  const [path, setPath] = useState(
    typeof window !== 'undefined' ? window.location.pathname : '/'
  );

  useEffect(() => {
    const updatePath = () => setPath(window.location.pathname);
    window.addEventListener('popstate', updatePath);
    window.addEventListener('app:navigate', updatePath as EventListener);
    return () => {
      window.removeEventListener('popstate', updatePath);
      window.removeEventListener('app:navigate', updatePath as EventListener);
    };
  }, []);

  return (
    <>
      <Toaster />
      {path.includes('faqs') ? <FAQPage /> : <HomePage />}
    </>
  );
}

export default App;
